<template>
<div v-if="true" class="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <!--
      Background overlay, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
    <div @click="$emit('changeVisibility')" class="fixed inset-0 dark:bg-gray-600 dark:bg-opacity-50 bg-gray-900 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

    <!-- This element is to trick the browser into centering the modal contents. -->
    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

    <!--
      Modal panel, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    -->
    <div class="inline-block align-bottom bg-white dark:bg-gray-900 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-1/3">
      <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 group h-auto dark:bg-gray-900">
          <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            <h3 class="text-lg leading-6 font-medium text-gray-900 dark:text-gray-300" id="modal-title">
              Definir pesquisador
            </h3>
            <div class="mt-4">
              <p class="uppercase text-sm text-gray-700 dark:text-gray-400">{{cnpjs.length}} Lojas a serem afetadas</p>
            </div>
            <div class="mt-4 h-52 ">
              <Autocomplete v-model="pesquisador" placeholder="Selecionar pesquisador" :list="pesquisadores" :validation="v$.pesquisador" desc="nome"/>
              <transition name="fade">
                <p v-if="errorMessage" class="text-red-500 text-sm">{{errorMessage}} Tente novamente</p>
              </transition>
            </div>
          </div>
      </div>
      <div class="bg-gray-50 dark:bg-gray-900 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
        <button @click="selectPesquisador()" type="button" class="btn w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm" :disabled="loading || v$.$invalid">
          <span v-if="loading" class="w-auto h-full">
            <Spinner width="4"/>
          </span>
          <span v-else>Adicionar</span>
        </button>
        <button @click="$emit('changeVisibility')" type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { PUT_PESQUISADORES_ADESAO, GET_PESQUISADORES_ADMIN, PUT_PESQUISADORES_ATIVAS } from '../../mixins/api.js'
import Autocomplete from '../Design/Autocomplete.vue'
import Spinner from '../Design/Spinner.vue'
import { ref } from 'vue'
import useVuelidate from '@vuelidate/core'
import { requiredOnly } from '@/mixins/validators.js'
import { displayNotification } from '@/mixins/notification.js'
import { useStore } from 'vuex'

export default {
    name: 'PesquisadorModal',
    components: {
        Autocomplete, Spinner
    },
    props: ['show', 'cnpjs', 'type'],
    setup (props, { emit }) {
        const pesquisadores = ref([])

        GET_PESQUISADORES_ADMIN().then(response => {
            pesquisadores.value = response.data
        })

        const pesquisador = ref('')
        const loading = ref(false)

        const rules = {
            pesquisador: requiredOnly()
        }

        const v$ = useVuelidate(rules, { pesquisador })

        const store = useStore()
        const errorMessage = ref('')
        const selectPesquisador = async () => {
            loading.value = true
            const body = { cnpj: props.cnpjs.join() }
            const id = pesquisadores.value.filter(x => x.nome === pesquisador.value)[0].id

            const ENDPOINT = (props.type === 'adesao' ? PUT_PESQUISADORES_ADESAO : PUT_PESQUISADORES_ATIVAS)

            await ENDPOINT(id, body).then(response => {
                displayNotification(response)
                emit('close')
            }).catch(e => {
                errorMessage.value = e.response.data.message
            })
            loading.value = false
        }

        return {
            pesquisador,
            pesquisadores,
            loading,
            selectPesquisador,
            errorMessage,
            v$
        }
    }
}
</script>

<style scoped>

.fade-enter-from {
  opacity: 0;
}
.fade-enter-to {
  opacity: 1;
}

.fade-enter-active {
  transition: all 0.3s ease-in-out;
}

.fade-leave-active {
  transition: all 0.3s ease-in-out;
}

.fade-leave-from {
  opacity: 1;
}

.fade-leave-to {
  opacity: 0;
}

</style>
